import {
    GETWITHOPENPAY,
    GETWITHOUTOPENPAY,
    GETOPENPAYCREDENTIALS,
    ASSOCIATEOPENPAY,
    UPDATEASSOCIATION,
    DELETEASSOCIATION,
    GET_ERRORS,
} from "../actions/types";

const initialState = {
    error: null,
    success: null,
    centersWithOpenpay: [],
    total: 0,
    centersWithoutOpenpay: [],
    openpayCredentials: [],
    actionType: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GETWITHOPENPAY:
            return {
                ...state,
                actionType: action.type,
                centersWithOpenpay: action.payload.centros,
                total: action.payload.total
            };
        case GETWITHOUTOPENPAY:
            return {
                ...state,
                actionType: action.type,
                centersWithoutOpenpay: action.payload
            }
        case GETOPENPAYCREDENTIALS:
            return {
                ...state,
                actionType: action.type,
                openpayCredentials: action.payload
            }
        case ASSOCIATEOPENPAY:
            return {
                ...state,
                actionType: action.type,
                success: "Se asocio correctamente la razon social al centro"
            }
        case UPDATEASSOCIATION:
            return {
                ...state,
                actionType: action.type,
                success: "Se actualizo correctamente la razon social del centro"
            }
        case DELETEASSOCIATION:
            return {
                ...state,
                actionType: action.type,
                success: "Se elimino correctamente la razon social del centro"
            }
        case GET_ERRORS:
            return {
                ...state,
                actionType: action.type,
                error: action.payload
            }
        default:
            return state;
    }
}